import React, { Component } from "react";
import { Table, Tag, Tooltip, Dropdown, Menu, Modal, Input, Alert, Empty, message } from "antd";
import { PlusOutlined, DownOutlined, EditOutlined, FilePdfOutlined, StopOutlined, SafetyCertificateOutlined } from "@ant-design/icons";
import { DynamicCardForm, ButtonItem } from "../../../../Components/Items";
import ModalPdfCMMS from "../componentes/ModalPdfCMMS";
import ModalCertificadoCMMS from "../Certificados/ModalCertificadoCMMS";
import { generarPdfCertificado } from "../Certificados/pdfCertificado";
import { VIGENCIAS, etiquetaResultado } from "../Certificados/certificadoComun";
import { cmmsPost, formatoFecha } from "../cmmsComun";

// Paso "Certificados" de la Orden de Servicio: los certificados de verificacion del equipo
// (F-SE-14). El servicio los carga (certificadosServicioCMMS) para mostrarlos tambien en
// Descargar ▾. props: servicio, certificados, plantillas, bloqueado, onCambio()
class CertificadosServicio extends Component {
    state = { modal: null, pdf: null, cancelar: null, cancelando: false };

    cancelar = async () => {
        const { id, motivo } = this.state.cancelar;
        if (!String(motivo || "").trim()) return message.warning("Escriba el motivo");
        this.setState({ cancelando: true });
        try {
            const res = await cmmsPost(this.props, "cancelarCertificadoCMMS", { id, motivo });
            if (res.data.success === 2) {
                message.success("Certificado cancelado");
                this.setState({ cancelar: null });
                this.props.onCambio();
            } else message.error(res.data.message || "No se pudo cancelar");
        } catch (error) {
            console.log(error);
            message.error("No se pudo cancelar");
        } finally {
            this.setState({ cancelando: false });
        }
    };

    menuPlantillas() {
        const plantillas = this.props.plantillas || [];
        const sugeridas = plantillas.filter((p) => p.sugerida);
        const otras = plantillas.filter((p) => !p.sugerida);
        const item = (p) => (
            <Menu.Item key={p._id}>
                <b>{p.clave}</b> {p.nombre}
            </Menu.Item>
        );
        return (
            <Menu onClick={({ key }) => this.setState({ modal: { plantillaId: key } })} style={{ maxHeight: 380, overflowY: "auto" }}>
                {sugeridas.length > 0 && <Menu.ItemGroup title="Del tipo de este equipo">{sugeridas.map(item)}</Menu.ItemGroup>}
                {otras.length > 0 && <Menu.ItemGroup title={sugeridas.length ? "Otras plantillas" : "Plantillas"}>{otras.map(item)}</Menu.ItemGroup>}
            </Menu>
        );
    }

    render() {
        const { servicio, certificados = [], plantillas = [], bloqueado } = this.props;
        if (!servicio) return <DynamicCardForm title="Certificados de verificación" xs={24}><Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Guarde el servicio para emitir certificados." /></DynamicCardForm>;
        const sinEquipo = !servicio.activoId;
        const puedeEmitir = !bloqueado && !sinEquipo && plantillas.length > 0;
        return (
            <DynamicCardForm
                title="Certificados de verificación"
                xs={24}
                headerRight={
                    !bloqueado && !sinEquipo ? (
                        plantillas.length ? (
                            <Dropdown trigger={["click"]} overlay={this.menuPlantillas()} disabled={!puedeEmitir}>
                                <ButtonItem type="primary" icon={<PlusOutlined />}>
                                    Nuevo certificado <DownOutlined />
                                </ButtonItem>
                            </Dropdown>
                        ) : (
                            <ButtonItem type="link" onClick={() => this.props.history.push("/panel/cmmsCertificados")}>
                                No hay plantillas: créelas en Certificados
                            </ButtonItem>
                        )
                    ) : null
                }
            >
                {sinEquipo ? (
                    <Alert type="info" showIcon message="El certificado es de un equipo: elija el equipo del servicio (paso General) y guarde." />
                ) : (
                    <>
                        <div className="cmms-ayuda">
                            Elija la plantilla (primero las del tipo de este equipo), capture lo inspeccionado y lo medido y el sistema calcula si cumple. Se descarga aquí o en Descargar ▾ de arriba.
                        </div>
                        <Table
                            size="small"
                            rowKey="_id"
                            pagination={false}
                            dataSource={certificados}
                            locale={{ emptyText: "Sin certificados en este servicio" }}
                            onRow={(r) => ({ onDoubleClick: () => this.setState({ modal: { certificadoId: r._id } }), style: { cursor: "pointer" } })}
                            columns={[
                                { title: "Folio", dataIndex: "codigo", width: 110, render: (v, r) => (r.estatus === 0 ? <span style={{ textDecoration: "line-through", color: "#9aa7b4" }}>{v}</span> : v) },
                                { title: "Certificado", dataIndex: "nombre", render: (v, r) => <span><SafetyCertificateOutlined style={{ color: "#2fb8d6" }} /> {v} <span className="cmms-agenda-item-sub">{r.clave}</span></span> },
                                { title: "Fecha", dataIndex: "fecha", width: 110, render: (v) => formatoFecha(v) },
                                {
                                    title: "Vigente hasta",
                                    dataIndex: "vigenciaHasta",
                                    width: 190,
                                    render: (v, r) =>
                                        r.estatus === 0 ? (
                                            <Tooltip title={r.motivoCancelacion}>
                                                <Tag>Cancelado</Tag>
                                            </Tooltip>
                                        ) : (
                                            <span>
                                                {formatoFecha(v)} {r.estatusVigencia && <Tag color={VIGENCIAS[r.estatusVigencia].color}>{VIGENCIAS[r.estatusVigencia].label}</Tag>}
                                            </span>
                                        ),
                                },
                                { title: "Resultado", dataIndex: "cumple", width: 130, render: (v, r) => <Tag color={etiquetaResultado(v, r.pendientes, r.otorgado).color}>{etiquetaResultado(v, r.pendientes, r.otorgado).label}</Tag> },
                                {
                                    title: "",
                                    width: 120,
                                    render: (r) => (
                                        <span style={{ display: "flex", gap: 4, justifyContent: "flex-end" }}>
                                            <Tooltip title={r.estatus === 0 || bloqueado ? "Ver" : "Capturar / editar"}>
                                                <ButtonItem type="default" size="small" cyan icon={<EditOutlined />} onClick={() => this.setState({ modal: { certificadoId: r._id } })} />
                                            </Tooltip>
                                            <Tooltip title="PDF">
                                                <ButtonItem type="default" size="small" blanco icon={<FilePdfOutlined />} onClick={() => this.setState({ pdf: r })} />
                                            </Tooltip>
                                            {r.estatus === 1 && !bloqueado && (
                                                <Tooltip title="Cancelar certificado">
                                                    <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} onClick={() => this.setState({ cancelar: { id: r._id, codigo: r.codigo, motivo: "" } })} />
                                                </Tooltip>
                                            )}
                                        </span>
                                    ),
                                },
                            ]}
                        />
                    </>
                )}
                <ModalCertificadoCMMS
                    visible={!!this.state.modal}
                    servicioId={servicio._id}
                    plantillaId={this.state.modal?.plantillaId}
                    certificadoId={this.state.modal?.certificadoId}
                    bloqueado={bloqueado}
                    onClose={(cambio) => this.setState({ modal: null }, () => cambio && this.props.onCambio())}
                />
                <ModalPdfCMMS
                    visible={!!this.state.pdf}
                    titulo={`Certificado ${this.state.pdf?.codigo || ""}`}
                    nombreArchivo={`Certificado_${this.state.pdf?.codigo || ""}.pdf`}
                    generar={() => generarPdfCertificado(this.props, this.state.pdf._id)}
                    onClose={() => this.setState({ pdf: null })}
                />
                <Modal
                    visible={!!this.state.cancelar}
                    title={`Cancelar certificado ${this.state.cancelar?.codigo || ""}`}
                    onCancel={() => this.setState({ cancelar: null })}
                    onOk={this.cancelar}
                    okText="Cancelar certificado"
                    cancelText="Regresar"
                    confirmLoading={this.state.cancelando}
                    okButtonProps={{ danger: true }}
                >
                    <div className="cmms-ayuda">El folio no se reutiliza. Si hay que corregir algo, mejor edite el certificado.</div>
                    <Input.TextArea rows={3} placeholder="Motivo" value={this.state.cancelar?.motivo} onChange={(e) => this.setState({ cancelar: { ...this.state.cancelar, motivo: e.target.value } })} />
                </Modal>
            </DynamicCardForm>
        );
    }
}

export default CertificadosServicio;
